<div *ngIf="email$ | async as email" class="px-2 max-w-7xl mr-auto">
  <div class="mb-8 [&_p]:mb-4 [&_p]:text-gray-600 [&_h3]:font-semibold [&_h3]:text-gray-900">
    <p>{{ email.created | date : 'long' }}</p>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4">
      <div class="overflow-hidden">
        <h3>From</h3>
        <p>{{ email.from }}</p>
      </div>

      <div class="overflow-hidden">
        <h3>To</h3>
        <p>{{ email.to }}</p>
      </div>
    </div>

    <h3>Subject</h3>
    <p>{{ email.subject }}</p>

    <button
      vs-button
      theme="primary"
      appearance="outline"
      class="!w-full sm:!w-auto"
      [disabled]="sending"
      (click)="resend()"
    >
      Resend
    </button>
  </div>

  <ng-container *ngIf="activity$ | async as activity">
    <div *ngIf="activity.length" class="mb-8">
      <ng-container *ngFor="let activity of activity">
        <div *ngIf="activity.status" class="mb-4">
          <div class="flex items-center gap-2 mb-0.5">
            <p class="text-sm text-gray-500">
              {{ activity.timestamp | date : 'shortDate' }} {{ activity.timestamp | date : 'mediumTime' }}
            </p>

            <div class="flex">
              <vs-badge [theme]="activity.status.theme">{{ activity.status.text }}</vs-badge>
            </div>
          </div>

          <p *ngIf="activity.message.userAgent" class="text-sm text-gray-500 mb-1">{{ activity.message.userAgent }}</p>

          <p class="row-start-2 col-span-full text-sm text-gray-700">{{ activity.status.description }}</p>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div class="max-w-[14rem] mb-4">
    <vs-input-container>
      <label slot="start">Format</label>
      <vs-select [value]="previewFormat" (valueChanges)="setPreviewFormat($event)">
        <li vs-select-option value="html">HTML</li>
        <li vs-select-option value="text">Plain text</li>
      </vs-select>
    </vs-input-container>
  </div>

  <pre
    *ngIf="previewFormat === 'text'"
    class="whitespace-pre-wrap break-words text-sm text-gray-900 font-mono"
    [textContent]="email.plainText"
  ></pre>
  <div *ngIf="previewFormat === 'html'" [innerHTML]="email.html | safe: 'html'"></div>
</div>
